import { getCompletedSurveys } from "./getCompletedSurveys";

export const isSurveyCompletedIcLocalStorage = (surveyId: number) => {
  return getCompletedSurveys().indexOf(surveyId) !== -1;
};
